<template>
  <Dropdown
    :hideArrow="true"
    ref="moreActionFilter"
    class="tab-item-filter"
    :bclass="bpadding"
    :lclass="lclass"
  >
    <template #button>
      <!-- <template v-if="!customDisplay"> -->
        
      <!-- </template> -->
      <!-- <template v-else> -->
        <slot name="current" :active="currentFilter.text">
          <p class="typo-button14 typo-medium text-light-high">{{ current }} {{ currentFilter.text }}</p>
          <i class="icon icon-arrow-down ml-half typo-button14 typo-medium text-light-high"></i>
        </slot>
      <!-- </template> -->
    </template>

    <div
      class="gp_dropdown-item"
      @click="itemFilterClick(sortFunc(item))"
      v-for="item in items"
      :key="'sort_'+item.value"
      :class="{ 'active': item.value == val }"
    >
      <p class="typo-button14 typo-medium text-light-high">{{item.text}}</p>
    </div>
  </Dropdown>
</template>

<script>
export default {
  name: "FilterPage",
  props: {
    lclass: String,
    type: String,
    value: String,
    items: {
      type: Array,
      default() {
        return [
          {
            value: "newest",
            text: this.$t("page.sort.latest"),
          },
          {
            value: "az",
            text: this.$t("page.sort.name", { order: this.$t("page.sort.az") }),
          },
          {
            value: "view",
            text: this.$t("page.sort.mostViewed"),
          },
        ];
      }
    },
    bpadding: {
      type: String,
      default: "px-0"
    },
    current: {
      type: String,
      default: "Sort: "
    }
  },
  data() {
    return {
      val: "newest"
    };
  },
  computed: {
    currentFilter() {
      let found = this.items.find(item => item.value == this.val);
      return found || this.items[0];
    }
  },
  watch: {
    value(newV) {
      this.val = newV;
    }
  },
  created() {
    this.val = this.value;
  },
  methods: {
    itemFilterClick(fn) {
      if (this.$refs.moreActionFilter) {
        this.$refs.moreActionFilter.toggleDropdown();
      }
      if (fn) fn();
    },
    sortFunc(sort) {
      this.val = sort.value;
      this.$emit("input", sort.value);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .btn-light3:hover {
    background-color: transparent;
    color: $mono3;
  }
}
</style>
